export const CLEAR_STORE = 'CLEAR_STORE';
export const LOGIN_USER = 'LOGIN_USER';
export const SET_ACTIVE_DROPDOWN = 'SET_ACTIVE_DROPDOWN';

export const setActiveDropdown = dropdownId => {
  return { type: SET_ACTIVE_DROPDOWN, payload: dropdownId };
};

// Tells the root reducer to completely clear the redux store, used for 401 encounters
export const clearStore = () => ({ type: CLEAR_STORE, payload: true });

export const loginUser = user => ({ type: LOGIN_USER, payload: user });
